module.exports = __webpack_public_path__ + "img/bancolombia.ba48124c.svg";